import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTracking } from '@PetSureAustralia/petsure-react-ui-library/distLib/hooks';
import { useFormContext } from 'react-hook-form';
import { VetDetailsPropTypes } from '../../../propTypes/vetDetails';
import { VetNameAndAddress } from '../vetNameAndAddress/vetNameAndAddress';

export const VetPracticesSearchResult = ({ result, clickHandler, autoCompleteField }) => {
  const { getValues } = useFormContext();

  const { serviceProviderNumber, serviceProvider } = result;

  const resultButton = useRef(null);

  useTracking({
    elementRef: resultButton,
    trackingProps: {
      label: 'Vet list selection',
      field: {
        inputType: 'button'
      }
    }
  });

  const GetSearchTerm = () => {
    return getValues(autoCompleteField);
  };

  return (
    <button
      ref={resultButton}
      type="button"
      key={serviceProviderNumber}
      result={result}
      value={serviceProviderNumber}
      onClick={() => clickHandler({ result, inputValue: serviceProvider })}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    >
      <VetNameAndAddress
        vetDetail={result}
        highlightText={GetSearchTerm()}
      />
    </button>
  );
};

VetPracticesSearchResult.propTypes = {
  result: VetDetailsPropTypes,
  clickHandler: PropTypes.func,
  autoCompleteField: PropTypes.string
};
